module.exports = __webpack_public_path__ + "img/gw-product-detail.225a7c47.png";